const state = {
  openTabs: [],
};

const getters = {
  getOpenTabs(_state) {
    return _state.openTabs;
  },
};

const actions = {
  addTab({ commit }, conversation) {
    commit('ADD_TAB', conversation);
  },
  removeTab({ commit }, conversationId) {
    commit('REMOVE_TAB', conversationId);
  },
  clearTabs({ commit }) {
    commit('CLEAR_TABS');
  },
};

const mutations = {
  ADD_TAB(_state, conversation) {
    if (!conversation || !conversation.id) return;
    const isAlreadyOpen = _state.openTabs.some(tab => tab.id === conversation.id);
    if (!isAlreadyOpen) {
      _state.openTabs.push(conversation);
    }
  },
  REMOVE_TAB(_state, conversationId) {
    _state.openTabs = _state.openTabs.filter(tab => tab.id !== conversationId);
  },
  CLEAR_TABS(_state) {
    _state.openTabs = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
